import React from 'react';
import { AlertCircleBoldSmall as AlertCircleBoldSmallCE } from '@wix/wix-ui-icons-common/classic-editor';
import { BaseUiNextContext } from '../../utils/BaseUINextContext';
import { iconColorByEditor } from '../iconsColors';
const AlertCircleBoldSmall = ({ color }) => {
    const context = React.useContext(BaseUiNextContext);
    let iconColor = '';
    if (color && (iconColorByEditor[`${color}-RE`] || iconColorByEditor[`${color}-CE`])) {
        iconColor = context?.theme === 'responsive' ? iconColorByEditor[`${color}-RE`] : iconColorByEditor[`${color}-CE`];
    }
    return React.createElement(AlertCircleBoldSmallCE, { color: iconColor });
};
AlertCircleBoldSmall.displayName = 'AlertCircleBoldSmall';
export default AlertCircleBoldSmall;
//# sourceMappingURL=AlertCircleBoldSmall.js.map